import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import { Navigate } from "react-router";
import { SubjectLandingComponent } from "./Component";

import "./Style.css";

const drawerWidth = 240;

class SubjectLanding extends Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            newObjectModalIsOpen: false,
            editObjectModalIsOpen: false,
            routeToNewObject: undefined,
            updateComponent: 0
        };

        this.openEditObjectModal = this.openEditObjectModal.bind(this);
        this.closeEditObjectModal = this.closeEditObjectModal.bind(this);
    }

    componentDidMount() {
        this.fetchSubjects();
    }

    fetchSubjects() {
        this.props.rootStore.subjectStore.fetchOne(
            this.props.match.params.user,
            this.props.match.params.subject
        );
    }

    noFunction() {
        console.log("Can't Remove Subject Object in this view");
    }

    removeSubjectObject(category_slug: string) {
        this.props.removeSubjectObject(this.props.subject_slug, category_slug);
    }

    openEditObjectModal(editObject: any) {
        this.setState({
            editObjectModalIsOpen: true,
            editObject: editObject
        });
    }

    closeEditObjectModal() {
        this.setState({
            editObjectModalIsOpen: false
        });
    }

    render() {
        const subject_slug = `${this.props.match.params.user}/${this.props.match.params.subject}`;

        if (this.state.routeToNewObject)
            <Navigate
                to={`/subjects/${subject_slug}/o/${this.state.routeToNewObject}`}
            />;

        let html: JSX.Element = <div></div>;

        const subject = this.props.rootStore.subjectStore.subjects.get(
            subject_slug
        );

        if (subject)
            return (
                <SubjectLandingComponent
                    subject={subject}
                    removeSubjectObject={this.removeSubjectObject}
                    isLoggedIn={this.props.rootStore.profileStore.isLoggedIn}
                />
            );

        return <div></div>;
    }
}

export default observer(SubjectLanding);
